import React from "react";
import { FaPhoneAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-10 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 text-center md:text-left">
        
        {/* Address */}
        <div>
          <h3 className="text-lg font-semibold mb-3">OUR ADDRESS</h3>
          <p className="text-sm text-gray-300 leading-relaxed">
            4th Floor, A-35, Street No.02, Madhu Vihar Rd, I.P Extention <br />
            Patparganj <br />
            New Delhi, India - 110001
          </p>
        </div>

        {/* Opening Hours */}
        <div>
          <h3 className="text-lg font-semibold mb-3">OPENING HOURS</h3>
          <p className="text-sm text-gray-300">Mon - Sat : 9:30 AM - 6:30 PM</p>
          <p className="text-sm text-gray-300">Sunday : Holiday</p>
        </div>

        {/* Toll Free Number */}
        <div className="flex flex-col items-center md:items-start">
          <h3 className="text-lg font-semibold mb-3">TOLL FREE</h3>
          <div className="flex items-center justify-center md:justify-start space-x-2 mb-2">
            <FaPhoneAlt className="text-yellow-400 text-xl" />
            <span className="text-sm text-gray-300 font-medium">
              1800-891-8455
            </span>
          </div>
          <p className="text-sm text-gray-300 mb-1">
            If you have any question, feel free to contact us
          </p>
          <p className="text-sm text-yellow-400 font-semibold break-words">
            info@wvtelevators.in
          </p>
        </div>
      </div>

      {/* Bottom line */}
      <div className="text-center text-gray-500 text-xs mt-10 border-t border-gray-700 pt-4">
        © {new Date().getFullYear()} WVTElevators. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
